import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingTenSlice = createSlice({
  name: 'customCounsellingTen',
  initialState: {
    allDataTen: null,
  },
  reducers: {
    setAllDataTen: (state, action) => {
      state.allDataTen = action.payload;
    },
  },
});

export const { setAllDataTen } = customCounsellingTenSlice.actions;
export default customCounsellingTenSlice.reducer;
